






















import { Component } from 'vue-property-decorator'
import { HsComponent } from '@hds/help-common/src/components/hs-components'

@Component
export default class extends HsComponent {
  // #region variables
  favoritePage: boolean = false

  get recentItems() {
    return this.$ustra.hs.store.menuData.recentMenus.map((recentMenu) => {
      const fav = !!this.$ustra.hs.store.menuData.myMenus.find((m) => m.menuId === recentMenu.menuId)
      return { ...recentMenu, fav }
    })
  }
  // #endregion

  // #region hooks
  // #endregion

  // #region methods

  // #endregion
  // #region watches
  // #endregion
}
